import PopupHighlight from "../components/PopupHighlight.vue";
import MultiStepIndicator from "../components/MultiStepIndicator.vue";
import BubbleHeadline from "../components/BubbleHeadline.vue";
import FormTabs from "../components/FormTabs.vue";
import DTButton from "../components/DTButton.vue";
import DTInput from "../components/DTInput.vue";
import DTDateInput from "../components/DTDateInput.vue";
import DTSelect from "../components/DTSelect.vue";
import DTColorRadio from "../components/DTColorRadio.vue";
import AutoProfileAI from "../components/AutoProfileAI.vue";
import AutoProfileAI2 from "../components/AutoProfileAI2.vue";
import MessageBox from "../components/MessageBox.vue";
import DTMilestones from "../components/DTMilestones.vue";
import BookPreview from "../components/BookPreview.vue";
import MerchPreview from "../components/MerchPreview.vue";
import ChangeRequest from "../components/ChangeRequest.vue";
import ExpectedDelivery from "../components/ExpectedDelivery.vue";
import UpSelling from "../components/UpSelling.vue";
import SelectableUpsells from "../components/SelectableUpsells.vue";
import PaymentMethods from "../components/PaymentMethods.vue";
import DTEmailSubmit from "../components/DTEmailSubmit.vue";
import DTCarousel from "../components/DTCarousel.vue";

export const componentDefinitions = [
    {
        component: PopupHighlight,
        name: "Highlight",
        image: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F41d38cbc176f4161b879b791bde2fd81",
        inputs: [
            {
                name: "highlightAssetUrl",
                friendlyName: "Asset URL",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png"],
                required: true,
            },
            {
                name: "highlightMobileAssetUrl",
                friendlyName: "Asset URL Mobile",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png"],
                required: true,
            },
            {
                name: "highlightHeadline",
                friendlyName: "Headline",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "highlightText",
                friendlyName: "Text",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "highlightMobileList",
                friendlyName: "Mobile Texts",
                helperText:
                    "Each item in the list will be displayed as a separate line",
                type: "list",
                subFields: [
                    {
                        name: "highlightMobileListItem",
                        friendlyName: "Text",
                        type: "string",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: "highlightUsps",
                friendlyName: "USPs",
                helperText:
                    "Maximum of 3 USPs (4 and above can result in layout issues)",
                type: "list",
                subFields: [
                    {
                        name: "uspAssetUrl",
                        friendlyName: "USP Asset URL",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                        required: true,
                    },
                    {
                        name: "uspAssetText",
                        friendlyName: "USP Text",
                        type: "string",
                        defaultValue: "",
                        required: true,
                    },
                ],
            },
            {
                name: "highlightPopupSlides",
                friendlyName: "Popup Assets",
                type: "list",
                subFields: [
                    {
                        name: "popupSlideAssetUrl",
                        friendlyName: "Popup Asset",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        component: MultiStepIndicator,
        name: "Multistep Indicator",
        image: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F99337735f2034b7892db601a42ecb84d",
        inputs: [
            {
                name: "showExplanation",
                friendlyName: "Show Explanation",
                helperText: "Show the explanation text above the steps",
                type: "boolean",
                defaultValue: true,
                required: true,
            },
            {
                name: "multistepIndicatorSteps",
                friendlyName: "Steps",
                type: "list",
                subFields: [
                    {
                        name: "heading",
                        friendlyName: "Heading",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        friendlyName: "Description",
                        type: "longText",
                        defaultValue: "",
                    },
                    {
                        name: "link",
                        friendlyName: "Link",
                        helperText:
                            "Link of the Step without domain (beginning with /)",
                        type: "url",
                        defaultValue: "",
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        component: BubbleHeadline,
        name: "Bubble Headline",
        image: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2F8a644a5ea91042d88b602cc6926d5104",
        inputs: [
            {
                name: "showBubble",
                friendlyName: "Show Bubble",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "bubbleContent",
                friendlyName: "Content of Bubble",
                type: "string",
                defaultValue: "",
            },
            {
                name: "headlineTag",
                friendlyName: "HTML Tag of Headline",
                type: "text",
                defaultValue: "h3",
                enum: [
                    {
                        label: "h1",
                        value: "h1",
                    },
                    {
                        label: "h2",
                        value: "h2",
                    },
                    {
                        label: "h3",
                        value: "h3",
                    },
                    {
                        label: "h4",
                        value: "h4",
                    },
                    {
                        label: "h5",
                        value: "h5",
                    },
                ],
                required: true,
            },
            {
                name: "headlineContent",
                friendlyName: "Headline Text",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "forceTextAlignLeftOnMobile",
                friendlyName: "Force Text Align Left on Mobile",
                type: "boolean",
                defaultValue: false,
            },
        ],
    },
    {
        component: FormTabs,
        name: "Form Tabs",
        image: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2Fec49d43293224a3e81d0225ae47429a2",
        canHaveChildren: true,
        inputs: [
            {
                name: "tabs",
                friendlyName: "Tabs",
                type: "list",
                subFields: [
                    {
                        name: "title",
                        friendlyName: "Tab Title",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "prefix",
                        friendlyName: "Tab Prefix",
                        helperText:
                            "If there are input fields in the content area, these are prefixed for communication with the backend (object-oriented)",
                        type: "string",
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        component: DTButton,
        name: "DT Button",
        image: "https://cdn.builder.io/api/v1/image/assets%2F5c32841cdfc646708f6dc9b494dadddc%2Feb12f6f34c8f452ea4a772d59b15474a",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "type",
                friendlyName: "Design Type",
                type: "text",
                defaultValue: "primary",
                enum: [
                    {
                        label: "Primary",
                        value: "primary",
                    },
                    {
                        label: "Secondary",
                        value: "secondary",
                    },
                    {
                        label: "Tertiary",
                        value: "tertiary",
                    },
                ],
                required: true,
            },
            {
                name: "text",
                friendlyName: "Button Text",
                type: "string",
                defaultValue: "Button",
                required: true,
            },
            {
                name: "link",
                friendlyName: "Link",
                helperText: "Not required if the button fires an action",
                type: "url",
                defaultValue: "",
            },
            {
                name: "target",
                friendlyName: "Link Target",
                helperText:
                    "Blank will open the Link in a new window. Not required if the button fires an action",
                type: "text",
                defaultValue: "_self",
                enum: [
                    {
                        label: "Self",
                        value: "_self",
                    },
                    {
                        label: "Blank",
                        value: "_blank",
                    },
                ],
            },
            {
                name: "icon",
                friendlyName: "Button Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "iconPosition",
                friendlyName: "Icon Position",
                type: "text",
                defaultValue: "left",
                enum: [
                    {
                        label: "Left",
                        value: "left",
                    },
                    {
                        label: "Right",
                        value: "right",
                    },
                ],
            },
            {
                name: "iconSize",
                friendlyName: "Icon Size",
                helperText: "The size of the icon in px",
                type: "text",
                defaultValue: "24",
            },
            {
                name: "eventBusEmit",
                friendlyName: "Event Bus Emit",
                helperText:
                    "The event name that is emitted when the button is clicked (must be implemented in custom components)",
                type: "string",
                defaultValue: "",
            },
        ],
    },
    {
        component: DTInput,
        name: "DT Input",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "type",
                friendlyName: "Type",
                type: "text",
                defaultValue: "text",
                enum: [
                    {
                        label: "Text",
                        value: "text",
                    },
                ],
                required: true,
            },
            {
                name: "payload",
                friendlyName: "Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "sharePayload",
                friendlyName: "Share Payload",
                helperText:
                    "If true the input field will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "placeholder",
                friendlyName: "Placeholder",
                type: "string",
                defaultValue: "",
            },
            {
                name: "autoHeight",
                friendlyName: "Auto Height",
                helperText:
                    "If true the input field will grow with the content. Only available for type text",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "speechToText",
                friendlyName: "Speech to Text",
                helperText:
                    "If true the input field will have a speech to text button",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "sendImmediately",
                friendlyName: "Sofort an Backend senden",
                helperText: "Sendet die Eingaben an das Backend, sobald der Benutzer das Feld verlässt",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "backendUrl",
                friendlyName: "Backend URL",
                helperText: "URL, an die die Eingaben gesendet werden sollen (nur relevant, wenn 'Sofort an Backend senden' aktiviert ist)",
                type: "string",
                defaultValue: "",
                showIf: "options.get('sendImmediately') === true",
            },
        ],
    },
    {
        component: DTDateInput,
        name: "DT Date Input",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "payload",
                friendlyName: "Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "sharePayload",
                friendlyName: "Share Payload",
                helperText:
                    "If true the input field will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "placeholder",
                friendlyName: "Placeholder",
                type: "string",
                defaultValue: "",
            },
            {
                name: "dateFormat",
                friendlyName: "Date Format",
                type: "text",
                defaultValue: "dd.mm.yyyy",
                enum: [
                    {
                        label: "DD.MM.YYYY",
                        value: "dd.mm.yyyy",
                    },
                    {
                        label: "MM.DD.YYYY",
                        value: "mm.dd.yyyy",
                    },
                    {
                        label: "DD/MM/YYYY (ES)",
                        value: "dd/mm/yyyy",
                    },
                    {
                        label: "MM/DD/YYYY (US)",
                        value: "mm/dd/yyyy",
                    },
                ],
                required: true,
            },
            {
                name: "errorMessageRequired",
                friendlyName: "Error Message Required",
                helperText:
                    "Error message shown when a required field is empty. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessageFormat",
                friendlyName: "Error Message Format",
                helperText:
                    "Use %format% as a placeholder for the date format. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: false,
            },
        ],
    },
    {
        component: DTSelect,
        name: "DT Select",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "payload",
                friendlyName: "Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "sharePayload",
                friendlyName: "Share Payload",
                helperText:
                    "If true the select field will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "options",
                friendlyName: "Options",
                type: "list",
                subFields: [
                    {
                        name: "value",
                        friendlyName: "Value",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "text",
                        friendlyName: "Text",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "selected",
                        friendlyName: "Selected",
                        type: "boolean",
                        defaultValue: false,
                    },
                ],
                required: true,
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "placeholder",
                friendlyName: "Placeholder",
                helperText:
                    "A placeholder is just a text that is displayed in the select field. It is not a selectable option and has no value. If you want to preselect an option, use the selected field in the options list",
                type: "string",
                defaultValue: "",
            },
        ],
    },
    {
        component: DTColorRadio,
        name: "DT Color Radio",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "payload",
                friendlyName: "Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "sharePayload",
                friendlyName: "Share Payload",
                helperText:
                    "If true the input field will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "options",
                friendlyName: "Options",
                type: "list",
                subFields: [
                    {
                        name: "value",
                        friendlyName: "Value",
                        helperText:
                            "Must be a hex color code (with # at the beginning!)",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "selected",
                        friendlyName: "Selected",
                        type: "boolean",
                        defaultValue: false,
                    },
                ],
                required: true,
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: false,
            },
        ],
    },
    {
        component: AutoProfileAI,
        name: "Auto Profile AI",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "sharePayloads",
                friendlyName: "Share Payloads",
                helperText:
                    "If true all input fields will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "eyeColorPayload",
                friendlyName: "Eye Color Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "eyeColorOptions",
                friendlyName: "Eye Color Options",
                type: "list",
                subFields: [
                    {
                        name: "value",
                        friendlyName: "Value",
                        helperText:
                            "Must be a hex color code (with # at the beginning!)",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "selected",
                        friendlyName: "Selected",
                        type: "boolean",
                        defaultValue: false,
                    },
                ],
                required: true,
            },
            {
                name: "eyeColorRequired",
                friendlyName: "Eye Color Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "skinColorPayload",
                friendlyName: "Skin Color Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "skinColorOptions",
                friendlyName: "Skin Color Options",
                type: "list",
                subFields: [
                    {
                        name: "value",
                        friendlyName: "Value",
                        helperText:
                            "Must be a hex color code (with # at the beginning!)",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "selected",
                        friendlyName: "Selected",
                        type: "boolean",
                        defaultValue: false,
                    },
                ],
                required: true,
            },
            {
                name: "skinColorRequired",
                friendlyName: "Skin Color Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "hairstylePayload",
                friendlyName: "Hairstyle Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "hairstyleRequired",
                friendlyName: "Hairstyle Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "miscPayload",
                friendlyName: "Miscellaneous Payload",
                helperText:
                    "Enter the name under which the field will be sent in the request body to the backend. Use JS object notation for dynamic values (e.g. person1.name). Note that a tab prefix is added in FormTabs.",
                type: "string",
                required: true,
            },
            {
                name: "miscRequired",
                friendlyName: "Miscellaneous Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "requestUrl",
                friendlyName: "Request URL",
                type: "url",
                defaultValue: "",
                required: true,
            },
        ],
    },
    {
        component: AutoProfileAI2,
        name: "Auto Profile AI 2",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "uploadButtonText",
                friendlyName: "Upload Button Text",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "imagePayload",
                friendlyName: "Image Payload",
                helperText: "Enter the name under which the image will be stored. Use JS object notation for dynamic values (e.g. person1.image).",
                type: "string",
                required: true,
            },
            {
                name: "sharePayload",
                friendlyName: "Share Payload",
                helperText: "If true the image will be shared Customizer-wide",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "popupTitle",
                friendlyName: "Popup Title",
                helperText: "Title of the popup and bottomsheet. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "recommendationsTitle",
                friendlyName: "Recommendations Title",
                helperText: "Title for the recommendations section. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "recommendations",
                friendlyName: "Recommendations",
                helperText: "List of recommendations separated by semicolons (;). Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "privacyText",
                friendlyName: "Privacy Text",
                helperText: "Text about privacy and GDPR compliance. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "mediaLibraryText",
                friendlyName: "Media Library Text",
                helperText: "Text for the media library button. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "cameraText",
                friendlyName: "Camera Text",
                helperText: "Text for the camera button. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "helpLinkText",
                friendlyName: "Help Link Text",
                helperText: "Text for the help link that opens the popup/bottomsheet. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "webhookUrl",
                friendlyName: "Webhook URL",
                helperText: "URL, an die das Bild gesendet wird. Die Antwort sollte einen Link enthalten, der im localStorage gespeichert wird.",
                type: "url",
                required: true,
            },
            {
                name: "errorTitle",
                friendlyName: "Error Title",
                helperText: "Titel der Fehlermeldung, die angezeigt wird, wenn das Bild nicht hochgeladen werden konnte. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessage",
                friendlyName: "Error Message",
                helperText: "Text der Fehlermeldung, die angezeigt wird, wenn das Bild nicht hochgeladen werden konnte. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessageTooLarge",
                friendlyName: "Error Message: Too Large",
                helperText: "Optional. Wird angezeigt, wenn das Bild zu groß ist (über 20 MB). Leer = Error Message.",
                type: "string",
                defaultValue: "",
            },
            {
                name: "errorMessageInvalidFile",
                friendlyName: "Error Message: Invalid File",
                helperText: "Optional. Wird angezeigt, wenn die Datei kein gültiges JPEG, PNG oder WebP ist. Leer = Error Message.",
                type: "string",
                defaultValue: "",
            }
        ],
    },
    {
        component: MessageBox,
        name: "Message Box",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "visible",
                friendlyName: "Visible",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "type",
                friendlyName: "Type",
                type: "text",
                defaultValue: "error",
                enum: [
                    {
                        label: "Error",
                        value: "error",
                    },
                    {
                        label: "Success",
                        value: "success",
                    },
                ],
                required: true,
            },
            {
                name: "showIcon",
                friendlyName: "Show Icon",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "icon",
                friendlyName: "Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "title",
                friendlyName: "Title",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "message",
                friendlyName: "Message",
                type: "string",
                defaultValue: "",
                required: true,
            },
            {
                name: "margin",
                friendlyName: "Margin",
                type: "text",
                helperText:
                    "The margin of the message box in px (notation: 0px 0px 0px 0px)",
                defaultValue: "0",
            },
            {
                name: "animation",
                friendlyName: "Animation",
                type: "boolean",
                defaultValue: true,
            },
        ],
    },
    {
        component: DTMilestones,
        name: "DT Milestones",
        image: "",
        inputs: [
            {
                name: "title",
                friendlyName: "Title",
                type: "string",
                defaultValue: "",
            },
            {
                name: "text",
                friendlyName: "Text",
                type: "longText",
                defaultValue: "",
            },
            {
                name: "milestoneLabel",
                friendlyName: "Milestone Label",
                helperText: "Label for milestones (e.g. 'Meilenstein' for German, 'Milestone' for English)",
                type: "string",
                defaultValue: "Meilenstein",
            },
            {
                name: "yearLabel",
                friendlyName: "Year Label",
                type: "string",
                defaultValue: "Jahr",
            },
            {
                name: "eventLabel",
                friendlyName: "Event Label",
                type: "string",
                defaultValue: "Ereignis",
            },
            {
                name: "milestoneYearPlaceholder",
                friendlyName: "Year Placeholder",
                type: "string",
                defaultValue: "",
            },
            {
                name: "milestoneEventPlaceholder",
                friendlyName: "Event Placeholder",
                type: "string",
                defaultValue: "",
            },
            {
                name: "lowerGate",
                friendlyName: "Lower Gate",
                helperText: "Number of milestones for free",
                type: "number",
                defaultValue: 3,
            },
            {
                name: "upperGate",
                friendlyName: "Upper Gate",
                helperText: "Max number of milestones",
                type: "number",
                defaultValue: 12,
            },
            {
                name: "milestonesPerAdd",
                friendlyName: "Milestones per Add",
                helperText:
                    "Number of milestones added per click (and must be paied)",
                type: "number",
                defaultValue: 3,
            },
            {
                name: "shopifyProductId",
                friendlyName: "Shopify Product ID",
                helperText:
                    "The ID of the Shopify product that will be added to the cart (optional - leave empty for free milestones)",
                type: "string",
                required: false,
            },
            {
                name: "messageboxTitle",
                friendlyName: "Message Box Title",
                type: "string",
                required: true,
            },
            {
                name: "messageboxText",
                friendlyName: "Message Box Text",
                type: "string",
                required: true,
            },
            {
                name: "messageboxMaxReachedTitle",
                friendlyName: "Message Box Title for Max Reached",
                type: "string",
                required: true,
            },
            {
                name: "messageboxMaxReachedText",
                friendlyName: "Message Box Text for Max Reached",
                type: "string",
                required: true,
            },
            {
                name: "addButtonIcon",
                friendlyName: "Add Button Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "addButtonText",
                friendlyName: "Add Button Text",
                type: "string",
                defaultValue: "Hinzufügen",
            },
        ],
    },
    {
        component: BookPreview,
        name: "Book Preview",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "requestUrl",
                friendlyName: "Request URL",
                type: "url",
                required: true,
            },
            {
                name: "requestMode",
                friendlyName: "Request Mode",
                helperText: "Use fetch for the existing synchronous request. Use poll to start a backend job and poll until completed.",
                type: "text",
                defaultValue: "fetch",
                enum: [
                    {
                        label: "Fetch",
                        value: "fetch",
                    },
                    {
                        label: "Poll",
                        value: "poll",
                    },
                ],
            },
            {
                name: "pollStartUrl",
                friendlyName: "Poll Start URL",
                helperText: "POST endpoint that receives the same payload as Request URL and returns jobId, status, optional pollIntervalMs and expiresAt.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollStatusUrl",
                friendlyName: "Poll Status URL",
                helperText: "Status endpoint. By default the frontend POSTs { jobId }. You can also include {jobId} or :jobId in the URL to use GET.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollIntervalMs",
                friendlyName: "Poll Interval (ms)",
                type: "number",
                defaultValue: 3000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollTimeoutMs",
                friendlyName: "Poll Timeout (ms)",
                helperText: "Set to 0 to disable the client-side timeout.",
                type: "number",
                defaultValue: 360000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "minLoadingDuration",
                friendlyName: "Minimum Loading Duration",
                type: "number",
                defaultValue: 10,
            },
            {
                name: "loadingBackgroundAssetUrl",
                friendlyName: "Loading Background Asset",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png"],
            },
            {
                name: "loadingSliderContent",
                friendlyName: "Loading Slider Content",
                type: "list",
                subFields: [
                    {
                        name: "loadingSlideAssetUrl",
                        friendlyName: "Loading Slide Asset",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                        required: true,
                    },
                ],
            },
            {
                name: "loadingSliderSlideDuration",
                friendlyName: "Loading Slider Slide Duration",
                helperText: "The duration of each slide in seconds",
                type: "number",
                defaultValue: 3,
            },
            {
                name: "titlePrefix",
                friendlyName: "Title Prefix",
                type: "string",
                defaultValue: "Die Geschichte von",
            },
            {
                name: "titleContent",
                friendlyName: "Title Content",
                helperText:
                    "%% path %% will be replaced with a stored object in LocalStorage",
                type: "string",
                defaultValue: "",
            },
            {
                name: "fadeInClass",
                friendlyName: "Fade In Class",
                helperText:
                    "The Class of the element that will be faded in after the loading time",
                type: "string",
                defaultValue: "",
            },
            {
                name: "hideAfterLoadingClass",
                friendlyName: "Hide After Loading Class",
                helperText:
                    "The Class of elements that will be hidden after the loading is complete",
                type: "string",
                defaultValue: "",
            },
            {
                name: "loadingStuckText",
                friendlyName: "Loading Stuck Text",
                helperText: "Text that appears when loading gets stuck at 99%. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "previewMode",
                friendlyName: "Preview Mode",
                helperText: "Choose between walnut (vertical A5) and softcover (square) preview mode",
                type: "text",
                defaultValue: "walnut",
                enum: [
                    {
                        label: "Walnut (A5 Vertical)",
                        value: "walnut",
                    },
                    {
                        label: "Softcover (Square)",
                        value: "softcover",
                    },
                ],
                required: true,
            },
        ],
    },
    {
        component: MerchPreview,
        name: "Merch Preview",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "requestUrl",
                friendlyName: "Request URL",
                type: "url",
                required: true,
            },
            {
                name: "requestMode",
                friendlyName: "Request Mode",
                helperText: "Use fetch for the existing synchronous request. Use poll to start a backend job and poll until completed.",
                type: "text",
                defaultValue: "fetch",
                enum: [
                    {
                        label: "Fetch",
                        value: "fetch",
                    },
                    {
                        label: "Poll",
                        value: "poll",
                    },
                ],
            },
            {
                name: "pollStartUrl",
                friendlyName: "Poll Start URL",
                helperText: "POST endpoint that receives the same payload as Request URL and returns jobId, status, optional pollIntervalMs and expiresAt.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollStatusUrl",
                friendlyName: "Poll Status URL",
                helperText: "Status endpoint. By default the frontend POSTs { jobId }. You can also include {jobId} or :jobId in the URL to use GET.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollIntervalMs",
                friendlyName: "Poll Interval (ms)",
                type: "number",
                defaultValue: 3000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollTimeoutMs",
                friendlyName: "Poll Timeout (ms)",
                helperText: "Set to 0 to disable the client-side timeout.",
                type: "number",
                defaultValue: 360000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "productType",
                friendlyName: "Produkt-Typ",
                type: "text",
                enum: [
                    { label: "Tasse", value: "mug" },
                    { label: "Video", value: "video" },
                    { label: "Tabletop", value: "tabletop" },
                    { label: "Puzzle", value: "puzzle" },
                    { label: "Leinwand", value: "canvas" },
                    { label: "Poster", value: "poster" },
                    { label: "Song", value: "song" },
                    { label: "Love Story Map", value: "love-story-map" }
                ],
                required: true,
            },
            {
                name: "minLoadingDuration",
                friendlyName: "Minimum Loading Duration",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "loadingBackgroundAssetUrl",
                friendlyName: "Loading Background Asset",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png"],
            },
            {
                name: "fadeInClass",
                friendlyName: "Fade In Class",
                helperText:
                    "The Class of the element that will be faded in after the loading time",
                type: "string",
                defaultValue: "",
            },
            {
                name: "hideAfterLoadingClass",
                friendlyName: "Hide After Loading Class",
                helperText:
                    "The Class of elements that will be hidden after the loading is complete",
                type: "string",
                defaultValue: "",
            },
            {
                name: "loadingStuckText",
                friendlyName: "Loading Stuck Text",
                helperText: "Text that appears when loading gets stuck at 99%. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "retryButtonText",
                friendlyName: "Retry Button Text",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "sectionTitleVerse1",
                friendlyName: "Section Title: Verse 1",
                type: "string",
                defaultValue: "Strophe 1",
                showIf: "options.get('productType') === 'song'",
            },
            {
                name: "sectionTitleVerse2",
                friendlyName: "Section Title: Verse 2",
                type: "string",
                defaultValue: "Strophe 2",
                showIf: "options.get('productType') === 'song'",
            },
            {
                name: "sectionTitleChorus",
                friendlyName: "Section Title: Chorus",
                type: "string",
                defaultValue: "Refrain",
                showIf: "options.get('productType') === 'song'",
            },
            {
                name: "sectionTitleBridge",
                friendlyName: "Section Title: Bridge",
                type: "string",
                defaultValue: "Bridge",
                showIf: "options.get('productType') === 'song'",
            },
        ],
    },
    {
        component: ChangeRequest,
        name: "Change Request",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "showMessageBox",
                friendlyName: "Show Message Box",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "messageBoxTitle",
                friendlyName: "Message Box Title",
                type: "string",
                defaultValue: "",
            },
            {
                name: "messageBoxText",
                friendlyName: "Message Box Text",
                type: "string",
                defaultValue: "",
            },
            {
                name: "errorMessageTitle",
                friendlyName: "Error Message Title",
                helperText: "Shown when the change request fails or its response does not arrive. Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessageText",
                friendlyName: "Error Message Text",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "longText",
            },
            {
                name: "headline",
                friendlyName: "Headline",
                type: "string",
                defaultValue: "Möchtest Du etwas ändern?",
            },

            {
                name: "placeholders",
                friendlyName: "Placeholders (Typewriter Effect)",
                helperText: "List of placeholders that will cycle with typewriter effect. Leave empty to use single placeholder.",
                type: "list",
                subFields: [
                    {
                        name: "placeholder",
                        friendlyName: "Placeholder Text",
                        type: "string",
                        required: true,
                    }
                ],
            },
            {
                name: "typewriterDelay",
                friendlyName: "Typewriter Delay (ms)",
                helperText: "Time between typing each character (in milliseconds)",
                type: "number",
                defaultValue: 50,
            },
            {
                name: "pauseBetweenPlaceholders",
                friendlyName: "Pause Between Placeholders (ms)",
                helperText: "Time to pause between different placeholders (in milliseconds)",
                type: "number",
                defaultValue: 2000,
            },
            {
                name: "buttonText",
                friendlyName: "Button Text",
                type: "string",
                defaultValue: "Geschichte anpassen",
            },
            {
                name: "buttonIcon",
                friendlyName: "Button Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "buttonIconPosition",
                friendlyName: "Button Icon Position",
                type: "text",
                defaultValue: "left",
                enum: [
                    {
                        label: "Left",
                        value: "left",
                    },
                    {
                        label: "Right",
                        value: "right",
                    },
                ],
            },
            {
                name: "requestUrl",
                friendlyName: "Request URL",
                type: "url",
                required: true,
            },
            {
                name: "requestMode",
                friendlyName: "Request Mode",
                helperText: "Use fetch for the existing synchronous change request. Use poll to start a backend job and poll until completed.",
                type: "text",
                defaultValue: "fetch",
                enum: [
                    {
                        label: "Fetch",
                        value: "fetch",
                    },
                    {
                        label: "Poll",
                        value: "poll",
                    },
                ],
            },
            {
                name: "pollStartUrl",
                friendlyName: "Poll Start URL",
                helperText: "POST endpoint that receives the same payload as Request URL and returns jobId, status, optional pollIntervalMs and expiresAt.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollStatusUrl",
                friendlyName: "Poll Status URL",
                helperText: "Status endpoint. By default the frontend POSTs { jobId }. You can also include {jobId} or :jobId in the URL to use GET.",
                type: "url",
                defaultValue: "",
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollIntervalMs",
                friendlyName: "Poll Interval (ms)",
                type: "number",
                defaultValue: 3000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "pollTimeoutMs",
                friendlyName: "Poll Timeout (ms)",
                helperText: "Set to 0 to disable the client-side timeout. Change requests can take several minutes.",
                type: "number",
                defaultValue: 900000,
                showIf: "options.get('requestMode') === 'poll'",
            },
            {
                name: "additionalPayloadSent",
                friendlyName: "Additional Payload Sent",
                type: "string",
                defaultValue: "",
            },
            {
                name: "maxChanges",
                friendlyName: "Maximum Number of Changes",
                helperText: "The maximum number of changes a user can make",
                type: "number",
                defaultValue: 5,
            },
        ],
    },
    {
        component: ExpectedDelivery,
        name: "Expected Delivery",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "icon",
                friendlyName: "Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "title",
                friendlyName: "Title",
                type: "string",
                defaultValue: "",
            },
            {
                name: "message",
                friendlyName: "Message",
                helperText:
                    "Use %%delivery%% as a placeholder for the delivery date",
                type: "string",
                defaultValue: "",
            },
            {
                name: "daysToAddMonday",
                friendlyName: "Lieferzeit für Montag (Tage)",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "daysToAddTuesday",
                friendlyName: "Lieferzeit für Dienstag (Tage)",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "daysToAddWednesday",
                friendlyName: "Lieferzeit für Mittwoch (Tage)",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "daysToAddThursday",
                friendlyName: "Lieferzeit für Donnerstag (Tage)",
                type: "number",
                defaultValue: 7,
            },
            {
                name: "daysToAddFriday",
                friendlyName: "Lieferzeit für Freitag (Tage)",
                type: "number",
                defaultValue: 6,
            },
            {
                name: "daysToAddSaturday",
                friendlyName: "Lieferzeit für Samstag (Tage)",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "daysToAddSunday",
                friendlyName: "Lieferzeit für Sonntag (Tage)",
                type: "number",
                defaultValue: 5,
            },
            {
                name: "skipSundays",
                friendlyName: "Sonntage überspringen",
                helperText: "Wenn aktiviert, wird das Lieferdatum auf Montag verschoben, falls es auf einen Sonntag fällt",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "dateFormat",
                friendlyName: "Datumsformat",
                helperText: "Wählen Sie zwischen EU-Format (z.B. 2. April 2025), US-Format (z.B. April 2, 2025), dem brasilianischen Format (z.B. 2 de abril de 2025), dem spanischen Format (z.B. 2 de abril de 2025), dem polnischen Format (z.B. 2 kwietnia 2025) oder dem schwedischen Format (z.B. 2 april 2025).",
                type: "text",
                defaultValue: "EU",
                enum: [
                    {
                        label: "EU-Format",
                        value: "EU",
                    },
                    {
                        label: "US-Format",
                        value: "US",
                    },
                    {
                        label: "BR-Format",
                        value: "BR",
                    },
                    {
                        label: "ES-Format",
                        value: "ES",
                    },
                    {
                        label: "PL-Format",
                        value: "PL",
                    },
                    {
                        label: "SE-Format",
                        value: "SE",
                    },
                ],
                required: true,
            },
        ],
    },
    {
        component: UpSelling,
        name: "Up Selling",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "products",
                friendlyName: "Products",
                type: "list",
                subFields: [
                    {
                        name: "productIds",
                        friendlyName: "Variant ID(s)",
                        helperText: "Eine einzelne Variant-ID oder mehrere durch Komma getrennt (z.B. 12345678 oder 12345678,87654321)",
                        type: "string",
                        required: false,
                    },
                    {
                        name: "productId",
                        friendlyName: "Legacy Variant ID (Nur für Abwärtskompatibilität)",
                        helperText: "Dieses Feld wird nur für die Abwärtskompatibilität mit bestehenden Bundles verwendet. Bitte 'Variant ID(s)' für neue Bundles verwenden.",
                        type: "string",
                        required: false,
                    },
                    {
                        name: "isSelected",
                        friendlyName: "Selected",
                        type: "boolean",
                        defaultValue: false,
                    },
                    {
                        name: "bestOffer",
                        friendlyName: "Best Offer",
                        type: "boolean",
                        defaultValue: false,
                    },
                    {
                        name: "bestOfferText",
                        friendlyName: "Best Offer Text",
                        type: "string",
                        defaultValue: "Bestes Angebot",
                    },
                    {
                        name: "productImage",
                        friendlyName: "Product Image",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                        required: true,
                    },
                    {
                        name: "labels",
                        friendlyName: "Labels",
                        helperText:
                            "Maximum of 2 labels on the product image seperated with ; (3 and above can result in layout issues)",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "headline",
                        friendlyName: "Headline",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "text",
                        friendlyName: "Text",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "uspOneIconUrl",
                        friendlyName: "USP 1 Asset",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                    },
                    {
                        name: "uspOneText",
                        friendlyName: "USP 1 Text",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "uspTwoIconUrl",
                        friendlyName: "USP 2 Asset",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                    },
                    {
                        name: "uspTwoText",
                        friendlyName: "USP 2 Text",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "uspThreeIconUrl",
                        friendlyName: "USP 3 Asset",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                    },
                    {
                        name: "uspThreeText",
                        friendlyName: "USP 3 Text",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "price",
                        friendlyName: "Price",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "savePrice",
                        friendlyName: "Save Price",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "hasInput",
                        friendlyName: "Has Input",
                        type: "boolean",
                        defaultValue: false,
                    },
                    {
                        name: "inputPayload",
                        friendlyName: "Input Payload",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "inputPlaceholder",
                        friendlyName: "Input Placeholder",
                        type: "string",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
    {
        component: SelectableUpsells,
        name: "Selectable Upsells",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "eyebrow",
                friendlyName: "Eyebrow",
                type: "string",
                defaultValue: "",
            },
            {
                name: "headline",
                friendlyName: "Headline",
                helperText: "Ohne Eintrag: Standard-Überschrift in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "text",
                friendlyName: "Text",
                type: "longText",
                defaultValue: "",
            },
            {
                name: "products",
                friendlyName: "Products",
                type: "list",
                subFields: [
                    {
                        name: "productIds",
                        friendlyName: "Variant ID(s)",
                        helperText: "Eine einzelne Variant-ID oder mehrere durch Komma getrennt (z.B. 12345678 oder 12345678,87654321)",
                        type: "string",
                        required: true,
                    },
                    {
                        name: "isSelected",
                        friendlyName: "Selected by default",
                        type: "boolean",
                        defaultValue: false,
                    },
                    {
                        name: "defaultQuantity",
                        friendlyName: "Default Quantity",
                        helperText: "Startmenge, wenn dieses Add-on ausgewählt ist. Mindestens 1.",
                        type: "number",
                        defaultValue: 1,
                    },
                    {
                        name: "maxQuantity",
                        friendlyName: "Max Quantity",
                        helperText: "Maximale Menge, die Kunden hinzufügen können. 0 oder leer bedeutet kein Limit.",
                        type: "number",
                        defaultValue: 0,
                    },
                    {
                        name: "productImage",
                        friendlyName: "Product Image",
                        type: "file",
                        allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
                        required: true,
                    },
                    {
                        name: "imageAlt",
                        friendlyName: "Image Alt Text",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "headline",
                        friendlyName: "Headline",
                        type: "string",
                        defaultValue: "",
                        required: true,
                    },
                    {
                        name: "text",
                        friendlyName: "Text",
                        type: "longText",
                        defaultValue: "",
                    },
                    {
                        name: "price",
                        friendlyName: "Price",
                        type: "string",
                        defaultValue: "",
                    },
                    {
                        name: "compareAtPrice",
                        friendlyName: "Compare At Price",
                        type: "string",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
    {
        component: PaymentMethods,
        name: "Payment Methods",
        image: "",
        inputs: [
            {
                name: "klarna",
                friendlyName: "Klarna",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "visa",
                friendlyName: "Visa",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "amex",
                friendlyName: "American Express",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "paypal",
                friendlyName: "PayPal",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "googlepay",
                friendlyName: "Google Pay",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "sofort",
                friendlyName: "Sofort",
                type: "boolean",
                defaultValue: true,
            },
        ],
    },
    {
        component: DTEmailSubmit,
        name: "DT Email Submit",
        image: "",
        inputs: [
            {
                name: "id",
                friendlyName: "ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "inputId",
                friendlyName: "Input ID",
                type: "string",
                defaultValue: "",
            },
            {
                name: "payload",
                friendlyName: "Payload",
                type: "string",
                defaultValue: "email",
            },
            {
                name: "placeholder",
                friendlyName: "Placeholder",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "required",
                friendlyName: "Required",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "buttonText",
                friendlyName: "Button Text",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "buttonIcon",
                friendlyName: "Button Icon",
                type: "file",
                allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            },
            {
                name: "buttonIconPosition",
                friendlyName: "Button Icon Position",
                type: "text",
                defaultValue: "right",
                enum: [
                    {
                        label: "Left",
                        value: "left",
                    },
                    {
                        label: "Right",
                        value: "right",
                    },
                ],
            },
            {
                name: "buttonType",
                friendlyName: "Button Type",
                type: "text",
                defaultValue: "secondary",
                enum: [
                    {
                        label: "Primary",
                        value: "primary",
                    },
                    {
                        label: "Secondary",
                        value: "secondary",
                    },
                    {
                        label: "Tertiary",
                        value: "tertiary",
                    },
                ],
            },
            {
                name: "webhookUrl",
                friendlyName: "Webhook URL",
                type: "url",
                required: true,
            },
            {
                name: "successMessage",
                friendlyName: "Success Message",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessageInvalid",
                friendlyName: "Error Message (Invalid Email)",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "errorMessageSubmit",
                friendlyName: "Error Message (Submit Error)",
                helperText: "Leer lassen = Standardtext in der Shop-Sprache.",
                type: "string",
            },
            {
                name: "autoHideTimeout",
                friendlyName: "Auto-Hide Timeout (Sekunden)",
                helperText: "Nach wie vielen Sekunden soll die Komponente automatisch ausgeblendet werden. 0 = nie ausblenden.",
                type: "number",
                defaultValue: 0,
            },
        ],
    },
    {
        component: DTCarousel,
        name: "DT Carousel",
        image: "",
        canHaveChildren: true,
        inputs: [
            {
                name: "slidesPerViewDesktop",
                friendlyName: "Slides per View (Desktop)",
                type: "number",
                defaultValue: 3,
                required: true,
            },
            {
                name: "slidesPerViewTablet",
                friendlyName: "Slides per View (Tablet)",
                type: "number",
                defaultValue: 2,
                required: true,
            },
            {
                name: "slidesPerViewMobile",
                friendlyName: "Slides per View (Mobile)",
                type: "number",
                defaultValue: 1,
                required: true,
            },
            {
                name: "autoplay",
                friendlyName: "Autoplay",
                type: "boolean",
                defaultValue: false,
            },
            {
                name: "autoplayDelay",
                friendlyName: "Autoplay Delay (ms)",
                helperText: "Duration in milliseconds between slide transitions",
                type: "number",
                defaultValue: 3000,
                showIf: "options.get('autoplay') === true",
            },
            {
                name: "showArrows",
                friendlyName: "Show Navigation Arrows",
                type: "boolean",
                defaultValue: true,
            },
            {
                name: "showPagination",
                friendlyName: "Show Pagination Dots",
                type: "boolean",
                defaultValue: true,
            },
        ],
    },
];
